import React, { forwardRef } from 'react';
import { List as MuiList } from '@mui/material';
import { isEmpty } from 'lodash';

import { reportErrorInProductionOrThrow } from '~/Utils';

/**
 This Component is a wrapper on MUI component.
 This component should be imported and not MUI directly!
**/

/**
 * Explicit List props based on actual usage in the codebase.
 */
export interface ListProps {
  /** If true, compact vertical padding is used */
  dense?: boolean;
  /** CSS class name to apply to the root element */
  className?: string;
  /** Inline styles applied to the root element */
  style?: React.CSSProperties;
  /** The content of the list, normally `ListItem` elements */
  children?: React.ReactNode;
}

const List = forwardRef<HTMLUListElement, ListProps>(({ dense, className, style, children, ...restProps }, ref) => {
  if (!isEmpty(restProps)) {
    reportErrorInProductionOrThrow(
      `Unexpected props passed to List: ${Object.keys(restProps).join(', ')}.
Examine if these need to be removed, or added explicitly to the ListProps interface and to the component's signature.`,
      true
    );
  }

  return (
    <MuiList dense={dense} className={className} style={style} ref={ref} {...restProps}>
      {children}
    </MuiList>
  );
});

List.displayName = 'List';

export default List;
